<template>
  <div class="map-nav">
    <MapNavButton
      v-for="(item, index) in mapNavList"
      :key="index"
      :label="item.label"
      :idle="item.icon.idle"
      :pressed="item.icon.pressed"
      :active="selectedItem === item.route"
      @click="mapNavHandle(item)" />
  </div>
</template>

<script>
import MapNavButton from './map-nav-button.vue';

export default {
  name: 'MapNav',
  components: {
    MapNavButton
  },
  data() {
    return {
      mapNavList: [{
        label: '返回列表',
        icon: {
          idle: require('../../assets/views/map/go-back.png'),
          pressed: require('../../assets/views/map/go-back-selected.png')
        }
      }, {
        label: '地图合并',
        route: 'vr-compose',
        icon: {
          idle: require('../../assets/views/map/vr-compose.png'),
          pressed: require('../../assets/views/map/vr-compose-selected.png')
        }
      }, {
        label: '地图对齐',
        route: 'cad-alignmet',
        icon: {
          idle: require('../../assets/views/map/cad-alignmet.png'),
          pressed: require('../../assets/views/map/cad-alignmet-selected.png')
        }
      }, {
        label: '路径绘制',
        route: 'draw-path',
        icon: {
          idle: require('../../assets/views/map/draw-path.png'),
          pressed: require('../../assets/views/map/draw-path-selected.png')
        }
      },{
        label: '触点生成',
        route: 'contact-path',
        icon: {
          idle: require('../../assets/views/map/contact-path.png'),
          pressed: require('../../assets/views/map/contact-path-selected.png')
        }
      }]
    };
  },
  computed: {
    selectedItem() {
      const routes = this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1, this.$route.path.length);
      if (routes && routes.length > 1) {
        return routes;
      }
      return null;
    }
  },
  methods: {
    mapNavHandle(item) {
      
      if (item.label === '返回列表') {
        this.$emit('mapNavHandle', '/x/map');
        return;
      }
      // if (item.label === '路径绘制') {
      //   return;
      // }
      
      const storeId = this.$store.state.storeId;
      const mapId = this.$store.state.mapId;
      this.$emit('mapNavHandle', `/x/map/${mapId}/editor/${item.route}?store_id=${storeId}`);
    }
  }
};
</script>

<style scoped lang="scss">
.map-nav{
  background-color: #101010;
  padding: 5px 0;
}
</style>
